module.exports = __webpack_public_path__ + "static/media/infiniti-phone.6560e622.svg";